import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptPeople } from "../adapters/adaptPerson";

interface FetchParams {
	page: number;
	pageSize: number;
	regionId?: number;
	areaId?: number;
	storeId?: number;
	archived?: boolean;
	search?: string;
}

const fetchPeople = async ({
	page,
	pageSize,
	regionId,
	areaId,
	storeId,
	archived,
	search
}: FetchParams) => {
	const response = await cmsClient.get<CMSPaginatedData<IRetailUser>>(
		"/homepage/admin/store/user/",
		{
			params: {
				page,
				page_size: pageSize,
				region: regionId,
				area: areaId,
				store: storeId,
				archived,
				search: search || undefined
			}
		}
	);

	return response.data;
};

const usePeople = (params: FetchParams) => {
	return useQuery(["admin-people", params], () => fetchPeople(params), {
		keepPreviousData: true,
		select: (data) => ({
			...data,
			results: adaptPeople(data.results)
		})
	});
};

export default usePeople;
